<template>
    <div class="pagetion d_f ai_c jc_c">
            <ul class="d_f">
                <li 
                    v-for="(item) in grouping" 
                    :key="item"
                    :class="pageActive==item?'active':''"
                    @click="thisPage(item)"
                    >{{item+num}}
                </li>
            </ul>
        <button type="primary" @click="pagenext">下一页</button>
        <p>共 {{page}}/{{pagelength}} 页</p>
    </div>
</template>

<script>
import index from './index'
export default {
    ...index,
    props : {
        defaultPage:{
            type : Number,
            default : 1,
        },
        pageSize : {
            type : [Number,Array],
            required: true,
        }

    }
}
</script>

<style lang="scss" scoped>
        .pagetion{
            height: 30px;
            margin-top: 30px;
            ul{
                margin: 0;
                li{
                    width: 30px;
                        height: 30px;
                        line-height: 30px;
                        text-align: center;
                        font-size: 18px;
                        margin: 0 5px;
                        cursor: pointer;
                    }
                    .active{
                        background-color: #0067cc;
                        color: #fff;
                    }
                }
                button{
                    margin: 0 20px;
                    cursor: pointer;
                    padding: 0 30px;
                    height: 100%;
                    background-color: #0067cc;
                    color: #fff;
                }
                p{
                    margin: 0;
                }
            }
</style>